import angular from 'angular';
let inject = ['$scope', '$uibModalInstance', 'product'];

class ModalQuantityCartController {
  constructor ($scope,$uibModalInstance, product) {
    this.$scope = $scope;
    this.product = angular.copy(product);
    this.$uibModalInstance = $uibModalInstance;
    this.itemQuantityToAdd = 1;
    this.user = {};
  }
  
  increaseItemQuantityToAdd () {
    if (!this.itemQuantityToAdd)
      this.itemQuantityToAdd = 1;
    else
      this.itemQuantityToAdd++;
  };
  
  decreaseItemQuantityToAdd () {
    if (!this.itemQuantityToAdd)
      this.itemQuantityToAdd = 1;
    else if (this.itemQuantityToAdd > 1) {
      this.itemQuantityToAdd--;
    }
  };
  
  addItemToCart(product, quantity) {
    this.$uibModalInstance.close({product: product, quantity : quantity});
  }
  
  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

ModalQuantityCartController.$inject = inject;

export default ModalQuantityCartController ;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/modal-quantity-cart/modal-quantity-cart.controller.js
 **/